<template>
    <div class="promoting_home">
        <div class="promoting1">
            <main>



                <div class="one img">
                    <img src="../img/背景提升/banner1.jpg" alt="" class="img_main">
                    <div class="cover"></div>
                </div>

                <!-- <div class="two img">
                    <img src="../img/背景提升/banner2.jpg" alt="" class="img_main">
                    <div class="cover"></div>
                </div> -->

                <div class="three img">
                    <img src="../img/背景提升/banner2.jpg" alt="" class="img_main">
                    <div class="cover"></div>
                </div>
                <div class="four img">
                    <img src="../img/背景提升/banner4.jpg" alt="" class="img_main">
                    <div class="cover"></div>
                </div>

                <div class="five img">
                    <img src="../img/背景提升/banner3.jpg" alt="" class="img_main">
                    <div class="cover"></div>
                </div>


                <button id="left" @click="prev()">
                    <div class="line_top"></div>
                    <div class="line_bot"></div>
                </button>
                <button id="right" @click="next()">
                    <div class="line_top"></div>
                    <div class="line_bot"></div>
                </button>
                <ul id="list" @click="handleList()">
                    <li @click="" class="dot_li"></li>
                    <li @click="" class="dot_li"></li>
                    <li @click="" class="dot_li"></li>
                    <li @click="" class="dot_li"></li>
                    <!-- <li @click="" class="dot_li"></li> -->
                </ul>
            </main>
        </div>

        <div class="promoting2">
            <div class="p2_top">
                <img src="../img/背景提升/Group 578.png" alt="">
                <div class="p2_top_textBox">
                    <p>对于中国学生来说，光有漂亮的分数已不能成为申请英美顶级院校的“制胜法宝”，背景提升项目也成为了申请过程中非常关键的“环节”。随着申请竞争越来越激烈，很多学生都开始在提升软实力方面投入努力，参与大量的课外活动进行背景提升。
                    </p>
                    <p>以哈佛大学的招生标准为例，参与社区活动、领导力、课外活动中的表现、个人特质等都是学校考量学生的点。这些都将成为申请中的闪光点之一。</p>
                    <p>课外活动的重要性早已不是秘密，而是公布于官网的“硬性要求”。</p>
                </div>
            </div>
            <div class="section_title">
                <p class="section_cn">什么是背景提升?</p>
                <p class="section_en">EXTRACURRICULAR ACTIVITIES</p>
            </div>
            <div class="p2_cont">

                <div class="p2_item">一段优秀的背景提升活动经历，会带来很多可以深挖的细节，从各个角度展现出学生的独特“人设”。这样的经历可以全面满足申请文书的填写需求，支撑起整份申请。 </div>
                <div class="p2_item">
                    RoSSo背景提升是目前市场上唯一一个专注于艺术专业留学生背景提升的品牌。从以作品集提升为主的夏校游学活动，到体现学生社会责任感的国际公益项目，再到以推荐信和实习证明为产出的职场辅导和实习，RoSSo背景提升全方位覆盖了艺术留学生的背景提升需求。
                </div>

            </div>
        </div>

        <div class="promoting3">
            <img src="../img/背景提升/Group 567.png" alt="">
        </div>

        <div class="promoting4">
            <div class="section_title">
                <p class="section_cn">RoSSo背景提升项目</p>
                <p class="section_en">RoSSo PROMOTING PROJECTS</p>
            </div>
            <div class="p4_cont">
                <div class="p4_left" id="p4_left" :style="{ height: `${windowHeight}px` }">
                    <el-menu default-active="1-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                        <el-submenu index="1">
                            <template slot="title">
                                <span>学术提升</span>
                            </template>
                            <el-menu-item index="1-1" @click="scrollGerm(0)">海外夏校</el-menu-item>
                            <el-menu-item index="1-2" @click="scrollGerm(1)">海外游学</el-menu-item>
                            <el-menu-item index="1-3" @click="scrollGerm(2)">艺术研学</el-menu-item>
                            <el-menu-item index="1-4" @click="scrollGerm(3)">海外大师短期课</el-menu-item>
                            <el-menu-item index="1-5" @click="scrollGerm(4)">STUDIO CLASS</el-menu-item>

                        </el-submenu>
                        <el-submenu index="2">
                            <template slot="title">
                                <span>公益活动</span>
                            </template>
                            <el-menu-item index="2-1" @click="scrollGerm(5)">国际义工旅行</el-menu-item>
                            <el-menu-item index="2-2" @click="scrollGerm(6)">国际艺术公益 </el-menu-item>


                        </el-submenu>
                        <el-submenu index="3">
                            <template slot="title">
                                <span>职场体验</span>
                            </template>
                            <el-menu-item index="3-1" @click="scrollGerm(7)">行业实训</el-menu-item>
                            <el-menu-item index="3-2" @click="scrollGerm(8)">职业导师</el-menu-item>
                            <el-menu-item index="3-3" @click="scrollGerm(9)">明星实习</el-menu-item>
                            <el-menu-item index="3-4" @click="scrollGerm(10)">海外实习</el-menu-item>


                        </el-submenu>


                    </el-menu>
                </div>
                <div class="p4_right">



                    <!-- 海外夏校 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">海外夏校</p>
                            <p class="p4_right_title_en">OVERSEA SUMMER SCHOOL</p>
                        </div>
                        <div class="p4_cont2">
                            <img src="../img/背景提升/Rectangle 1006.png" alt="" class="p4_c2_left">
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    带领学生前往海外顶尖艺术大学、英国G5高校、美国藤校等院校参加官方短期课程，获得学校官方证书。或带领学生参访顶级学府，与招生官面对面交流。在学习交流的同时，游玩当地知名景点，度过完美夏天！
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>定制课程：</span>顶级名校专门定制的夏校课程，在校园里沉浸式体验名校课程；</li>
                                    <li><span>教授亲授：</span>名校教授全程亲自指导项目产出，为作品集项目添砖加瓦；</li>
                                    <li><span>官方证书：</span>合作院校官方结课证书+教授推荐信机会，高含金量背景提升；</li>
                                    <li><span>名校参访：</span>探访更多周边知名学府，与招生官面对面，获取一手梦校资讯；</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>海外实地</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-18岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">海外夏校火热报名中！</div>
                            <div class="p4_cont_imgbox">

                                <div class="swiper mySwiperP1">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/1.jpg" alt="">
                                            <img src="../img/背景提升/海外夏校-海报/2.jpg" alt="">
                                            <img src="../img/背景提升/海外夏校-海报/3.jpg" alt="">
                                        </div>

                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外夏校-海报/4.jpg" alt="">
                                            <img src="../img/背景提升/海外夏校-海报/5.jpg" alt="">
                                            <img src="../img/背景提升/海外夏校-海报/6.jpg" alt="">
                                        </div>


                                    </div>
                                    <div class="swiper-pagination"></div>
                                    <div class="swiper-button-next"></div>
                                    <div class="swiper-button-prev"></div>

                                </div>


                            </div>
                        </div>

                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">

                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>

                    </div>

                    <!-- 海外游学 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">海外游学</p>
                            <p class="p4_right_title_en">OVERSEA STUDY TOUR</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外游学/3.jpg" alt="">
                                    </div>


                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    联合海外学术机构、艺术工坊、艺术家工作室、名校毕业导师，为学生带来贴合实践的专业短期课程体验。通过学+游的综合体验，在提升学术能力，收获证书和产出的同时，拓宽学生的眼界！
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>高金访学：</span>海外知名学术机构和艺术工坊定制课程，提升设计思维;</li>
                                    <li><span>艺术巡游：</span>探访知名博物馆，打卡知名艺术街区，领略海外艺术魅力；</li>
                                    <li><span>人文风光：</span>探索极致自然景观，体验当地人生活，培养全球化视野；</li>
                                    <li><span>背景提升：</span>合作机构官方结课证书 + 作品集产出 + 推荐信机会。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>海外实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">海外游学火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/海外游学-海报/1.jpg" alt="">
                                <img src="../img/背景提升/海外游学-海报/2.jpg" alt="">

                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 艺术研学 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">艺术研学</p>
                            <p class="p4_right_title_en">ART STUDY TRIP</p>
                        </div>
                        <div class="p4_cont2">

                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">

                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/2.jpg" alt="">
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/6.jpg" alt="">
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/艺术研学/11.jpg" alt="">
                                    </div>

                                </div>
                            </div>

                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    艺术研学项目与优秀的国家非物质文化遗产传承人、研究机构、匠人工坊合作，通过深入学习非遗技艺，为学生提供深度了解、学习国家非物质文化遗产的机会。同时将非遗元素运用到现在设计中，丰富作品集特色与内涵！
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>田野调查：</span>探访兼具自然和人文的目的地，发掘历史和背后的绚丽文化；</li>
                                    <li><span>文化传承：</span>深入学习非遗技艺，并将学到的非遗元素运用到现代设计中</li>
                                    <li><span>双师辅导：</span>海外名校毕业导师+非遗导师全程指导，产出直接用于作品集；</li>
                                    <li><span>背景提升：</span>获得官方结课证书、非遗导师推荐信机会，助力留学申请。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>国内实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">艺术研学火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/艺术研学-海报/1.jpg" alt="">
                                <img src="../img/背景提升/艺术研学-海报/2.jpg" alt="">
                                <img src="../img/背景提升/艺术研学-海报/3.jpg" alt="">


                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 海外大师短期课 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">海外大师短期课</p>
                            <p class="p4_right_title_en">MASTER CLASS</p>
                        </div>
                        <div class="p4_cont2">
                            <img src="../img/背景提升/Rectangle 1007.png" alt="" class="p4_c2_left">
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    邀请海外顶尖院校的在职教授开设主题性短期课程，辅导学生了解中西方思维差异，提升设计思维和创新能力，短时间内进行高质量的学术和作品集产出。在海外大师的加持指导下，同学们诞生了非常多让人眼前一亮的作品！
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>对话大师：</span>周高强度海外名校教授与中文助教双师授课；</li>
                                    <li><span>小班教学：</span>严控班级规模，保证每位同学都能得到教授的针对性指导；</li>
                                    <li><span>项目产出：</span>可用于作品集的特定主题的项目产出；</li>
                                    <li><span>证书收获：</span>不仅可获得课程证书，还有教授推荐信机会，丰富 PS/CV。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>远程线上</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">海外大师短期课火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <div class="swiper mySwiperP1">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/1.jpg" alt="">

                                            <img src="../img/背景提升/海外大师短期课-海报/2.jpg" alt="">

                                            <img src="../img/背景提升/海外大师短期课-海报/3.jpg" alt="">
                                        </div>
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/海外大师短期课-海报/4.jpg" alt="">

                                            <img src="../img/背景提升/海外大师短期课-海报/5.jpg" alt="">
                                            <img src="../img/背景提升/海外大师短期课-海报/6.jpg" alt="">
                                        </div>
                                        <div class="swiper-slide">


                                            <img src="../img/背景提升/海外大师短期课-海报/7.jpg" alt="">
                                            <img src="../img/背景提升/海外大师短期课-海报/8.jpg" alt="">
                                            <img src="../img/背景提升/Group 566.png" alt=""
                                                style="border:none;visibility: hidden;">
                                        </div>

                                    </div>
                                    <div class="swiper-pagination"></div>
                                    <div class="swiper-button-next"></div>
                                    <div class="swiper-button-prev"></div>
                                </div>

                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- STUDIO CLASS -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">STUDIO CLASS</p>
                            <p class="p4_right_title_en">STUDIO CLASS</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/Studio Class/3.jpg" alt="">
                                    </div>



                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    深受同学们喜欢的金牌课程。小班课和小组协作的课堂形式，不仅能够让每位同学从导师身上、从同学身上获得灵感，启迪艺术思维，更让同学们提前适应欧美 TOP
                                    艺术院校的教学模式，获得艺术作品集的创作收获。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>主题丰富：</span>艺术概念探索、前沿设计和技术、跨学科融合设计；</li>
                                    <li><span>有趣好玩：</span>探索艺术边界，突破创作瓶颈，跨学科开拓眼界；</li>
                                    <li><span>师资强大：</span>名校毕业学长导师 + 行业专家 + 艺术家 + 竞赛评委</li>
                                    <li><span>产出丰富：</span>有趣的作品集作品 + 导师推荐信机会 + 企业实习机会。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>远程线上</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">海外夏校火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <div class="swiper mySwiperP1">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/1.jpg" alt="">
                                            <img src="../img/背景提升/Studio class-海报/2.jpg" alt="">
                                            <img src="../img/背景提升/Studio class-海报/3.jpg" alt="">
                                        </div>

                                        <div class="swiper-slide">
                                            <img src="../img/背景提升/Studio class-海报/4.jpg" alt="">
                                            <img src="../img/背景提升/Group 566.png" alt=""
                                                style="border:none;visibility: hidden;">
                                            <img src="../img/背景提升/Group 566.png" alt=""
                                                style="border:none;visibility: hidden;">
                                        </div>


                                    </div>
                                    <div class="swiper-pagination"></div>
                                    <div class="swiper-button-next"></div>
                                    <div class="swiper-button-prev"></div>
                                </div>
                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>



                    <!-- 国际义工旅行 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">国际义工旅行</p>
                            <p class="p4_right_title_en">INTERNATIONAL VOLUNTEER</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/2.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国际义工旅行/3.jpg" alt="">
                                    </div>




                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    国际义工旅行与海外公益组织和机构合作，带领学生前往世界各地。在专业机构的指导下参与动植物保育、环境保护、国际支教等项目，同时开展公益的艺术创作，用作品向世界发出自己的声音。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>官方合作：</span>与国际NGO及当地公益组织官方合作的定制项目；</li>
                                    <li><span>专业指导：</span>专业机构老师全程指导，注重每位学生的过程体验；</li>
                                    <li><span>大地艺术：</span>名校毕业艺术导师带领学生在当地完成大地艺术作品；</li>
                                    <li><span>高金证书：</span>收获 NGO 及公益组织的多份公益证书，助力留学申请。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>海外实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>不限</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>15-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">国际义工旅行火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/国际义工旅行-海报/1.jpg" alt="">
                                <img src="../img/背景提升/国际义工旅行-海报/2.jpg" alt="">


                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 国内艺术公益 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">国内艺术公益</p>
                            <p class="p4_right_title_en">DOMESTIC VOLUNTEER</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国内艺术公益/1.jpg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/国内艺术公益/2.jpg" alt="">
                                    </div>




                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    国内艺术研学项目，将结合联合国教科文组织支持的国际画展项目，在参与公益活动的同时，将自己的所见所感转为为艺术创作。在名校毕业导师的指导下，完成绘画作品，获得画展证书、联合国教科文徽章及推荐信。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>科学考察：</span>深入热带雨林，了解雨林动植物和生态系统，进行科学实验；</li>
                                    <li><span>动物保护：</span>近距离接触国家一级保护动物亚洲象，体验动物保护志愿者；</li>
                                    <li><span>背景提升：</span>获得亚洲象保护协会公益证书 + 联合国国际画展荣誉证书；</li>
                                    <li><span>高性价比：</span>用参加一次活动的时间和费用，完成多个不同类型的背景提升。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>国内实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>不限</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>12-18 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">国内艺术公益火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/国内艺术公益-海报/1.jpg" alt="">

                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>



                    <!-- 行业实训 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">行业实训</p>
                            <p class="p4_right_title_en">TRAINEE PROGRAM</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/1.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/2.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/3.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/4.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/5.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/6.jpeg" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/行业实训-回顾/7.jpeg" alt="">
                                    </div>
                                </div>

                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    行业实训为申请留学和毕业求职的同学提供高水平的行业活动体验。通过与行业大咖的对话、优秀企业的参访、以及真实商业项目的工作体验，为长期职业规划打下扎实的行业基础。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>真实项目：</span>参与真实的商业项目，体会理论知识与工作实操的区别；</li>
                                    <li><span>对话大咖：</span>探访行业展会，对话行业大咖，深度了解行业内幕；</li>
                                    <li><span>项目证明：</span>获得官方证明助力留学求职，更有机会获得大咖推荐信；</li>
                                    <li><span>积累人脉：</span>提前积累优质行业人脉，为职业发展铺平道路。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>国内/海外实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>根据具体项目</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>15-20人/班</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>16-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">行业实训火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/行业实训-海报/1.jpg" alt="">
                                <img src="../img/背景提升/行业实训-海报/2.jpg" alt="">


                            </div>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 职场导师 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">职场导师</p>
                            <p class="p4_right_title_en">MENTORSHIP</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/1.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/2.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/职场导师/3.png" alt="">
                                    </div>


                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    职场导师邀请国内外时尚设计、互联网、世界 500 强企业的优秀企业导师，为学生提供接触行业一线工作内容、积累行业人脉的机会，并获得申请留学所必须的推荐信。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>职业规划：</span>企业导师详细分析行业及岗位，找对人生方向；</li>
                                    <li><span>职场启蒙：</span>近距离接触国家一级保护动物亚洲象，体验动物保护志愿者；</li>
                                    <li><span>高金推荐：</span>名企导师推荐信，为留学申请和求职加分；</li>
                                    <li><span>服务跟踪：</span>教务老师全程跟踪，定制专属提升方案。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>远程线上</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>不限</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>1对1辅导</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>16-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <!-- <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">职场导师火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/01.jpg" alt="">
                                <img src="../img/背景提升/02.jpg" alt="">
                                <img src="../img/背景提升/03.jpg" alt="">

                            </div>
                        </div> -->
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 明星实习 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">明星实习</p>
                            <p class="p4_right_title_en">DOMESTIC INTERNSHIP</p>
                        </div>
                        <div class="p4_cont2">

                            <img src="../img/背景提升/明星实习/1.png" alt="" class="p4_c2_left">
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    明星实习为正在申请留学国外名校和正在为求职而寻找实习经验的年轻学生提供在行业一线工作实践的机会，并出具实习证明，让每一个学生都有机会成为一个合格的求职者，找到理想的人生目标。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>求职辅导：</span>1对1简历 + 面试指导，提升申请质量；</li>
                                    <li><span>名企实习：</span>明星企业 1-2 个月实地实习，收获工作经验；</li>
                                    <li><span>实习证明：</span>企业官方实习证明，为留学申请和求职加分；</li>
                                    <li><span>服务跟踪：</span>教务老师全程跟踪，定制专属提升方案。 PS/CV。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>国内实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>不限</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>1对1咨询</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>18-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <!-- <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">明星实习火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/01.jpg" alt="">
                                <img src="../img/背景提升/02.jpg" alt="">
                                <img src="../img/背景提升/03.jpg" alt="">

                            </div>
                        </div> -->
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>

                    <!-- 海外实习 -->
                    <div class="p4_right_item">
                        <div class="scroll_position"></div>
                        <div class="p4_right_title">
                            <p class="p4_right_title_cn">海外实习</p>
                            <p class="p4_right_title_en">OVERSEA INTERNSHIP</p>
                        </div>
                        <div class="p4_cont2">
                            <div class="swiper mySwiperLast1">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/1.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/2.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../img/背景提升/海外实习/3.png" alt="">
                                    </div>


                                </div>
                            </div>
                            <div class="p4_c2_right">
                                <img src="../img/背景提升/Group 557.png" alt="">
                                <div>
                                    中国留学生如果想要在国外找一份名企实习是一件特别困难的事。海外实习致力于打造高端实习体验，为已经在海外留学的学生量身定制在地实习和求职计划，帮助学生顺利入职行业全球一线企业。
                                </div>
                                <img src="../img/背景提升/Group 557.png" alt="">
                            </div>
                        </div>
                        <div class="p4_cont3">
                            <div class="p4_cont3_left">
                                <div>项目亮点：</div>
                                <ul>
                                    <li><span>高管直投：</span>绕过海投，直接把简历内推给公司高管，提高获得面试的机会；</li>
                                    <li><span>门槛降低：</span>同等岗位即使比公司的招聘要求稍低一点也可以获得 offer 机会；</li>
                                    <li><span>海量岗位：</span>覆盖英、美、日等传统留学国家，专为艺术设计学生量身打造；</li>
                                    <li><span>成功案例：</span>累计帮助超过 1000 人获得世界 500 强等企业实习和就业机会。</li>
                                </ul>
                            </div>
                            <div class="p4_cont3_right">

                                <ul>
                                    <div>项目地点：</div>
                                    <li>国内实地</li>

                                </ul>
                                <ul>
                                    <div>适合专业：</div>
                                    <li>不限</li>

                                </ul>
                                <ul>
                                    <div>项目模式：</div>
                                    <li>1对1咨询</li>

                                </ul>
                                <ul>
                                    <div>适合年龄：</div>
                                    <li>18-21 岁</li>

                                </ul>
                            </div>
                        </div>
                        <!-- <div class="p4_cont4">
                            <div class="p4_cont4_line"></div>
                            <div class="p4_cont_title">海外实习火热报名中！</div>
                            <div class="p4_cont_imgbox">
                                <img src="../img/背景提升/01.jpg" alt="">
                                <img src="../img/背景提升/02.jpg" alt="">
                                <img src="../img/背景提升/03.jpg" alt="">

                            </div>
                        </div> -->
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <img src="../img/背景提升/Group 564.png" alt="" class="right_more"></a>
                    </div>



                </div>

            </div>
        </div>


        <!-- 最外层div -->
    </div>
</template>
<script>
import "@/assets/css/promoting.css"

import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-cube";
import "swiper/css/effect-fade";

import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default {
    data() {
        return {

            arr: [{
                transform: "translateZ(-100px)  translateX(-120px)",
                z: "10084",
                opacity: 0.8
            },

            {
                transform: "translateZ(0px)  translateX(0px)",
                z: "10086",
                opacity: 0
            },

            {
                transform: "translateZ(-100px)  translateX(120px)",
                z: "10084",
                opacity: 0.8
            },
            {
                transform: "translateZ(-100px)  translateX(120px)",
                z: "10084",
                opacity: 0.8
            },
            ],
            n: 1,
            windowHeight: 500,
        }

    },
    created() {
        // this.fun1()
        this.windowHeight = window.innerHeight - 90

        // console.log( window.innerHeight,"create");

    },

    methods: {
        p4LeftHeight() {
            var p4_left = document.getElementById("p4_left")
            // console.log(window.innerHeight, p4_left.style.height);
            p4_left.style.height = window.innerHeight - 90

        },
        jopkefu() {
            window.open("https://www11c1.53kf.com/webCompany.php?kf_sign=DI0MjMTY4MkzODE1NTc0NTYwMDMzMDAzNzIxNjgzNTM=&arg=10168353&style=1&guest_id=12950638033002&language=zh-cn&charset=gbk&referer=http%3A%2F%2Fwww.rossoarts.com%2F&keyword=http%3A%2F%2Flocalhost%3A8081%2F&tpl=crystal_blue&uid=392070b4b477c77869f6a6a47a1dfee8&is_group=&timeStamp=1680242953439&ucust_id=", '_blank')
        },
        scrollGerm(val) {
            // console.log(val);
            var p4_right_item = document.getElementsByClassName("p4_right_item")
            var scroll_position = document.getElementsByClassName("scroll_position")
            // p4_right_item[val].scrollIntoView({
            //     block: 'start',
            //     behavior: 'smooth',

            // })
            scroll_position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
            // console.log(document.documentElement.scrollTop = p4_right_item[val].offsetTop - 90);
        },
        windowScroll() {
            var p4_right_item = document.getElementsByClassName("p4_right_item")
            var el_menu_item = document.getElementsByClassName("el-menu-item")
            var el_submenu = document.getElementsByClassName("el-submenu")
            var el_menu = document.getElementsByClassName("el-menu--inline")

            var st = document.documentElement.scrollTop;
            var h = window.innerHeight;
            // console.log(st);
            for (let i = 0; i < p4_right_item.length; i++) {
                var ositem = p4_right_item[i].offsetTop;

                if (ositem <= st + h / 2) {

                    for (let j = 0; j < el_menu_item.length; j++) {

                        el_menu_item[j].style.fontWeight = "400"
                        // console.log("j", j, "   ", "i", i);


                    }
                    el_menu_item[i].style.fontWeight = "bold"

                    if (st > 7200) {
                        // el_submenu[1].classList.toggle("is-opened")
                        // el_submenu[1].ariaExpanded = "true";

                        // // console.log(el_menu);
                        // el_menu[1].style.display = "block"
                        // console.log(el_menu[1].$refs);   
                    }
                    // if (st > 9600) {
                    //     el_submenu[2].classList.add("is-opened")
                    //     el_menu[2].style.display = "block"
                    //     // console.log(">>>>>>666666");
                    // }

                }
            }
        },
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
            var elsubmenuTitle = document.getElementsByClassName("el-submenu__title")
            // elsubmenuTitle[key-1].style.backgroundColor = "red"
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        next() {
            var imgs = document.getElementsByClassName("img");
            var lis = document.getElementsByClassName("dot_li")
            var cover = document.getElementsByClassName("cover")

            lis[this.n].style.backgroundColor = "#D9D9D9";
            this.n++;

            this.arr.unshift(this.arr.pop())
            // console.log(this.arr);

            for (var i = 0; i < imgs.length; i++) {
                // console.log(i, cover[i].style.opacity);
                imgs[i].style.transform = this.arr[i].transform
                imgs[i].style.zIndex = this.arr[i].z;
                cover[i].style.opacity = this.arr[i].opacity;

            }
            if (this.n > lis.length - 1) {
                this.n = 0;
                lis[this.n].style.backgroundColor = "#FB6333";
            }
            lis[this.n].style.backgroundColor = "#FB6333";
        },
        prev() {
            var imgs = document.getElementsByClassName("img");
            var lis = document.getElementsByClassName("dot_li")
            var cover = document.getElementsByClassName("cover")

            lis[this.n].style.backgroundColor = "#D9D9D9";
            this.n--
            this.arr.push(this.arr.shift())
            // console.log(this.n,"lis.length",lis.length);
            // console.log(this.arr);
            for (var i = 0; i < imgs.length; i++) {

                imgs[i].style.transform = this.arr[i].transform
                imgs[i].style.zIndex = this.arr[i].z;
                cover[i].style.opacity = this.arr[i].opacity;

            }
            if (this.n < 0) {
                this.n = lis.length - 1;
            }
            lis[this.n].style.backgroundColor = "#FB6333";
        },
        handleList() {
            var lis = document.getElementsByClassName("dot_li")
            var imgs = document.getElementsByClassName("img");
            var cover = document.getElementsByClassName("cover")
            // console.log(event.target);
            for (var i = 0; i < lis.length; i++) {
                lis[i].setAttribute("index", i)
            }
            var index = event.target.getAttribute("index")

            // console.log(index);
            for (var i = 0; i < Math.abs(index - this.n); i++) {


                if (index > this.n) {
                    console.log(this.arr.unshift(this.arr.pop()));
                } else {
                    console.log((this.arr.push(this.arr.shift())), "i");
                }
            }
            // console.log(this.arr);
            this.n = index
            for (var i = 0; i < imgs.length; i++) {

                imgs[i].style.transform = this.arr[i].transform
                imgs[i].style.zIndex = this.arr[i].z;
                cover[i].style.opacity = this.arr[i].opacity;

            }
            if (event.target.nodeName == "LI") {

                for (var j = 0; j < lis.length; j++) {
                    lis[j].style.backgroundColor = "#D9D9D9"
                }

                event.target.style.backgroundColor = "#FB6333";

            }
        },
        fun1() {
            var imgs = document.getElementsByClassName("img");
            var lis = document.getElementsByClassName("dot_li")
            var cover = document.getElementsByClassName("cover")

            var n = 1;

            lis[n].style.backgroundColor = "#FB6333";
            cover[n].style.opacity = "0"


        }
    },

    mounted() {
        this.fun1(),
            this.p4LeftHeight()
        window.addEventListener("scroll", this.windowScroll, true);
        var swiper = new Swiper(".mySwiperP1", {
            // slidesPerView: 3,
            // spaceBetween: 30,
            // effect:'cube', 
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        var swiper = new Swiper(".mySwiperLast1", {
            spaceBetween: 30,
            effect: "fade",
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },

        });
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll, true);
    },
}
</script>